<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	name: "App",

	watch: {
		'$route.params.unidade'(to, from) {
			if (to != from) {
				localStorage.removeItem('analiseAtual');
				this.$store.commit('analiseIa/SET_ANALISE_SELECIONADA', {})
			}
		}
	}
}
</script>